module.exports = __webpack_public_path__ + "media/img/why/bg-testi-ec1c3b6a49756aefd69276dbeb12fbe5.png";